module.exports = __webpack_public_path__ + "img/MURM.f33b5688.png";